export class UnauthorizedError extends Error {
  override readonly name = 'UnauthorizedError';
  constructor() {
    super('Unauthorized');
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  constructor() {
    super('Network error');
  }
}

export class ServerError extends Error {
  override readonly name = 'ServerError';
  constructor() {
    super('Server error');
  }
}

export class InvalidMeasurementInputError extends Error {
  override readonly name = 'InvalidMeasurementInputError';
  constructor(message = 'Invalid measurement input') {
    super(message);
  }
}

export class InvalidDateRangeError extends Error {
  override readonly name = 'InvalidDateRangeError';
  constructor(message = 'Invalid date range') {
    super(message);
  }
}

export class BodyMetricNotFoundError extends Error {
  override readonly name = 'BodyMetricNotFoundError';
  constructor(message = 'Metric not found') {
    super(message);
  }
}

export class MeasurementEntryNotFoundError extends Error {
  override readonly name = 'MeasurementEntryNotFoundError';
  constructor(message = 'Measurement entry not found') {
    super(message);
  }
}

export class MetricNameConflictError extends Error {
  override readonly name = 'MetricNameConflictError';
  constructor(message = 'A metric with this name already exists') {
    super(message);
  }
}

/** The server refused the session: a future date or a disabled metric. */
export class MeasurementSessionRejectedError extends Error {
  override readonly name = 'MeasurementSessionRejectedError';
  constructor(message = 'Measurement session rejected') {
    super(message);
  }
}

export type BodyMeasurementsError =
  | UnauthorizedError
  | NetworkError
  | ServerError
  | InvalidMeasurementInputError
  | InvalidDateRangeError
  | BodyMetricNotFoundError
  | MeasurementEntryNotFoundError
  | MetricNameConflictError
  | MeasurementSessionRejectedError;
